import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  persistReducer,
  persistStore,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './root-reducer';

export const persistConfig = {
  key: 'root',
  // bump this version whenever a Redux state shape change would leave existing
  // localStorage caches in a broken or incompatible state (e.g. a new required
  // field is added, or a subcollection like dividers fails to hydrate correctly)
  version: 2,
  storage,
  blacklist: ['user', 'map'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          // Ignore the fetchTrip action that deals with Firebase Timestamps
          'trip/retrieve/fulfilled',
        ],
        ignoredPaths: [
          'map.map',
          // Ignore Firebase Timestamp objects that might be stored temporarily
          'trip.currentTrip.cards',
          'trip.trips',
        ],
        ignoredActionPaths: [
          // Ignore action payloads that might contain Firebase Timestamps
          'payload.value',
          'payload.timestamp',
          'payload.lastOpened',
          'payload.cards',
          'payload.trips',
          'meta.arg',
        ],
      },
    });

    return process.env.NODE_ENV === 'development'
      ? // biome-ignore lint/suspicious/noExplicitAny: ok
        defaultMiddleware.concat(logger as any)
      : defaultMiddleware;
  },
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
